export const tramites = [
    {
        "anio" : "Direccion General de Responsabilidades Administrativas",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Atención de Quejas y Denuncias",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/443"
                    },
                    {
                        "nombre" : "Constancias de No Inhabilitación",
                        "url" : "https://contraloriahidalgo.gob.mx/inhabilitacion/constancias/"
                    },
                    {
                        "nombre" : "Inconformidades en Materia de Adquisiciones",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/425"
                    },
                    {
                        "nombre" : "Inconformidades en Materia de Obra Pública",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/424"
                    },
                    {
                        "nombre" : "Sistema de Declaración Patrimonial DeclaraNet",
                        "url" : "http://declaranet.hidalgo.gob.mx:5000/"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Normatividad",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    // {
                    //     "nombre" : "Padrón de Proveedores",
                    //     "url" : "Tramite/Proveedores"
                    // },
                    // {
                    //     "nombre" : "Padrón de Contratistas",
                    //     "url" : "Tramite/Contratistas"
                    // },
                    {
                        "nombre" : "Revisión de Bases",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/480"
                    },
                    {
                        "nombre" : "Sistema de Registro de Proveedores y Contratistas",
                        "url" : "https://srpcehcontraloria.hidalgo.gob.mx/rext/"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Vinculación",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Asesoría y Capacitación en Materia de Contraloría Social",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/426"
                    },
                    {
                        "nombre" : "Fortalecimiento de valores y cultura a la legalidad para niños y niñas",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/6584"
                    },
                    {
                        "nombre" : "Recepción y Seguimiento de Quejas, Denuncias y Solicitudes de Contraloría Social",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/437"
                    }
                ]
            },

            {
                "nombre" : "Contraloría Social ",
                "contenidoTramite" : [
                    {
                        "nombre" : "Aviso de privacidad",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/426"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Auditoría Gubernamental",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Quejas de Obra Pública",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/6582"
                    }
                ]
            }
        ]
    }
]